import React from 'react';
import bem from 'utils/bem';
import useCart from 'components/CartWidget/useCart';
import Icon from 'components/Icon';

const { block } = bem('shop-item-teaser-cart-button');

const CartButton = ({id, maxAmount, soonActive}) => {
    const { updateItem } = useCart(id);

    const disabled = maxAmount <= 0 || soonActive;

    const onButtonClick = (e) => {
        e.preventDefault();
        if (maxAmount <= 0 || soonActive) {
            return;
        }
        updateItem();
    }

    if (disabled) { return null; }

    return (
        <div className={ block() } onClick={ onButtonClick }>
            <Icon name={ 'shopping-cart' }/>
        </div>
    )
}

export default CartButton;
